<!-- A label always exists. When the design has no room for a visible one it is
     rendered for assistive tech only, because a placeholder is not a label:
     it disappears as soon as the user types, and several screen readers do not
     announce it at all. -->
<label
  *ngIf="!projectedLabel"
  [attr.for]="fieldId"
  [class.rak-field__label]="label"
  [class.rak-field__label--sr]="!label"
>{{ accessibleName }}<span *ngIf="required" aria-hidden="true"> *</span></label>

<ng-content></ng-content>

<!-- role="alert" so the message is announced when it appears. The id is what
     aria-describedby on the control points at. -->
<div class="rak-field__errors" [id]="errorId" role="alert" *ngIf="showErrors">
  <ng-content select="[fieldErrors]"></ng-content>
</div>
